// Czysta logika listy faktur — bez wywołań API, żeby dało się ją testować.
import { monthLabel } from './balancing';

// Okres rozliczeniowy faktury to miesiąc period_start — faktury są miesięczne
export const periodKey = (invoice) => (invoice?.period_start || '').slice(0, 7);

export const periodLabel = (key) => {
    const [year, month] = key.split('-').map(Number);
    return month >= 1 && month <= 12 ? monthLabel(year, month) : key;
};

export const invoicePeriodLabel = (invoice) => periodLabel(periodKey(invoice));

// Okresy z listy, od najnowszego; „wszystkie” ('') dokłada widok
export const periodOptions = (invoices) =>
    [...new Set(invoices.map(periodKey).filter(Boolean))]
        .sort((a, b) => b.localeCompare(a))
        .map((key) => ({ key, label: periodLabel(key) }));

export const filterByPeriod = (invoices, key) =>
    (key ? invoices.filter((invoice) => periodKey(invoice) === key) : invoices);
